<div class="consultar-atendimentos-container">
  <div class="header">
    <div class="row align-items-center">
      <div class="col-md-8">
        <h1>Consultar Atendimentos</h1>
      </div>
      <div class="col-md-4 text-end">
        <button class="btn btn-primary" (click)="novoAtendimento()">Novo Atendimento</button>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-3 col-sm-6 mb-3">
        <div class="form-group">
          <label for="filtroCliente">Cliente:</label>
          <input
            type="text"
            id="filtroCliente"
            class="form-control"
            [(ngModel)]="filtros.cliente"
            placeholder="Filtrar por cliente">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 mb-3">
        <div class="form-group">
          <label for="filtroTipo">Tipo:</label>
          <select
            id="filtroTipo"
            class="form-control"
            [(ngModel)]="filtros.tipo">
            <option value="">Todos os tipos</option>
            <option *ngFor="let tipo of tiposAtendimento" [value]="tipo.id">{{ tipo.nome }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 mb-3">
        <div class="form-group">
          <label for="filtroOnlinePresencial">Online/Presencial:</label>
          <select
            id="filtroOnlinePresencial"
            class="form-control"
            [(ngModel)]="filtros.onlinePresencial">
            <option value="">Todos</option>
            <option value="online">Online</option>
            <option value="presencial">Presencial</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 mb-3">
        <div class="form-group">
          <label for="filtroSituacao">Situação:</label>
          <select
            id="filtroSituacao"
            class="form-control"
            [(ngModel)]="filtros.situacao">
            <option value="">Todas as situações</option>
            <option value="a confirmar">A Confirmar</option>
            <option value="primeiro atend">Primeiro Atend</option>
            <option value="finalizado">Finalizado</option>
            <option value="recebido">Recebido</option>
            <option value="processo">Processo</option>
            <option value="cancelado">Cancelado</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 mb-3">
        <div class="form-group">
          <label for="filtroStatusAgendamento">Status Agendamento:</label>
          <select
            id="filtroStatusAgendamento"
            class="form-control"
            [(ngModel)]="filtros.statusAgendamento">
            <option value="">Todos os status</option>
            <option *ngFor="let status of statusAgendamentoOpcoes" [value]="status.nome.toLowerCase()">
              {{ status.nome }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 mb-3">
        <div class="form-group">
          <label for="filtroDataInicio">Data Início:</label>
          <input
            type="date"
            id="filtroDataInicio"
            class="form-control"
            [(ngModel)]="filtros.dataInicio">
        </div>
      </div>
      <div class="col-md-3 col-sm-6 mb-3">
        <div class="form-group">
          <label for="filtroDataFim">Data Fim:</label>
          <input
            type="date"
            id="filtroDataFim"
            class="form-control"
            [(ngModel)]="filtros.dataFim">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <button class="btn btn-primary me-2" (click)="pesquisarAtendimentos()">
          <i class="fa fa-search"></i> Buscar
        </button>
        <button class="btn btn-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <div
    class="table-responsive"
    [class.dragging]="isArrastandoTabela"
    #tableScrollContainer
    (mousedown)="iniciarArrasteTabela($event, tableScrollContainer)"
    (mousemove)="moverArrasteTabela($event, tableScrollContainer)"
    (mouseup)="finalizarArrasteTabela()"
    (mouseleave)="finalizarArrasteTabela()">
    <table class="table table-hover">
      <thead class="table-light">
        <tr>
          <th class="sticky-column" style="width: 8%;">Sobrenome</th>
          <th style="width: 12%;">Cliente</th>
          <th style="width: 8%;">Data</th>
          <th style="width: 8%;">Início</th>
          <th style="width: 8%;">Fim</th>
          <th style="width: 8%;">Tipo</th>
          <th style="width: 10%;"></th>
          <th style="width: 10%;">Reunião</th>
          <th style="width: 10%;">Situação</th>
          <th style="width: 12%;">Status Agendamento</th>
          <th style="width: 16%; min-width: 150px;">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let atendimento of atendimentosPaginados">
          <td class="sticky-column">{{ atendimento.sobrenome }}</td>
          <td>{{ atendimento.cliente }}</td>
          <td>{{ atendimento.data | date:'dd/MM/yyyy' }}</td>
          <td>{{ atendimento.horaInicio }}</td>
          <td>{{ atendimento.horaFim }}</td>
                     <td>
             {{ atendimento.tipo }}
           </td>
          <td>
            <span [class]="getOnlinePresencialClass(atendimento.onlinePresencial)">
              {{ atendimento.onlinePresencial }}
            </span>
          </td>
          <td>
            <span [class]="getReuniaoClass(atendimento.reuniao)">
              {{ atendimento.reuniao }}
            </span>
          </td>
          <td>
            <button 
              class="btn btn-sm status-btn" 
              [class]="getSituacaoClass(atendimento.situacao)"
              (click)="alterarSituacao(atendimento)"
              [title]="'Clique para alterar situação: ' + atendimento.situacao">
              {{ atendimento.situacao }}
            </button>
          </td>
          <td>
            <button 
              class="btn btn-sm status-btn" 
              [class]="getStatusAgendamentoClass(atendimento.statusAgendamento)"
              (click)="alterarStatusAgendamento(atendimento)"
              [title]="'Clique para alterar status: ' + atendimento.statusAgendamento">
              {{ atendimento.statusAgendamento }}
            </button>
          </td>
          <td style="min-width: 150px;">
            <div class="btn-group" role="group">
              <button class="btn btn-sm btn-arvore me-1" (click)="abrirArvoreGenealogica(atendimento)" title="Árvore genealógica">
                <i class="fa fa-sitemap"></i> Árvore
              </button>
              <button class="btn btn-sm btn-orcamento me-1" (click)="abrirOrcamentos(atendimento)" title="Orçamentos">
                <i class="fa fa-money"></i> Orçamento
              </button>
              <button class="btn btn-sm btn-documentos me-1" (click)="abrirDocumentos(atendimento)" title="Documentos">
                <i class="fa fa-file-text-o"></i> Doc
              </button>
              <button class="btn btn-sm btn-upload me-1" (click)="abrirUploadDocumentos(atendimento)" title="Upload de documentos">
                <i class="fa fa-upload"></i> Upload
              </button>
              <button class="btn btn-sm btn-linkmeeting me-1" (click)="abrirModalLinkMeeting(atendimento)" title="Link da reunião">
                <i class="fa fa-link"></i> Link
              </button>
              <button class="btn btn-sm btn-formulario me-1" (click)="abrirVisualizacaoFormulario(atendimento)" title="Visualizar formulário">
                <i class="fa fa-eye"></i> Formulário
              </button>
              <button class="btn btn-sm btn-info me-1" (click)="verDetalhes(atendimento)" title="Ver detalhes">
                <i class="fa fa-eye"></i> Ver
              </button>
              <button class="btn btn-sm btn-warning me-1" (click)="editarAtendimento(atendimento)" title="Editar">
                <i class="fa fa-edit"></i> Editar
              </button>
              <button class="btn btn-sm btn-danger" (click)="excluirAtendimento(atendimento)" title="Excluir">
                <i class="fa fa-trash"></i> Excluir
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="!loading && atendimentosPaginados.length === 0">
          <td colspan="11" class="text-center text-muted">Nenhum atendimento encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="!loading && atendimentosFiltrados.length > 0">
    <div class="text-muted">
      Exibindo {{ (paginaAtual - 1) * itensPorPagina + 1 }} a {{ Math.min(paginaAtual * itensPorPagina, atendimentosFiltrados.length) }}
      de {{ atendimentosFiltrados.length }} registros
    </div>

    <div class="d-flex align-items-center gap-2">
      <button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()" [disabled]="paginaAtual === 1">
        Anterior
      </button>
      <span class="text-muted">Página {{ paginaAtual }} de {{ totalPaginas || 1 }}</span>
      <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">
        Próxima
      </button>
    </div>
  </div>

  <div class="modal-backdrop-custom" *ngIf="exibirModalSituacao">
    <div class="modal-card">
      <div class="modal-card-header">
        <h5 class="mb-0">Aviso</h5>
        <button type="button" class="btn-close" (click)="fecharModalSituacao()" [disabled]="salvandoSituacao"></button>
      </div>

      <div class="modal-card-body">
        <p class="mb-2">Tem certeza que deseja alterar a situação deste Atendimento?</p>
        <div class="form-group mb-0">
          <label for="novaSituacao"><strong>Nova Situação:</strong></label>
          <select
            id="novaSituacao"
            class="form-control"
            [(ngModel)]="novaSituacaoId">
            <option [ngValue]="null">--- Selecione ---</option>
            <option *ngFor="let item of situacoesAtendimento" [ngValue]="item.id">
              {{ item.nome }}
            </option>
          </select>
        </div>
      </div>

      <div class="modal-card-footer">
        <button type="button" class="btn btn-light" (click)="fecharModalSituacao()" [disabled]="salvandoSituacao">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="salvarNovaSituacao()" [disabled]="salvandoSituacao">
          {{ salvandoSituacao ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>

  <div class="modal-backdrop-custom" *ngIf="exibirModalStatusAgendamento">
    <div class="modal-card">
      <div class="modal-card-header">
        <h5 class="mb-0">Aviso</h5>
        <button type="button" class="btn-close" (click)="fecharModalStatusAgendamento()" [disabled]="salvandoStatus"></button>
      </div>

      <div class="modal-card-body">
        <p class="mb-2">Tem certeza que deseja alterar o status deste Atendimento?</p>
        <div class="form-group mb-0">
          <label for="novoStatusAgendamento"><strong>Novo Status:</strong></label>
          <select
            id="novoStatusAgendamento"
            class="form-control"
            [(ngModel)]="novoStatusId">
            <option [ngValue]="null">--- Selecione ---</option>
            <option *ngFor="let item of statusAgendamentoOpcoes" [ngValue]="item.id">
              {{ item.nome }}
            </option>
          </select>
        </div>
      </div>

      <div class="modal-card-footer">
        <button type="button" class="btn btn-light" (click)="fecharModalStatusAgendamento()" [disabled]="salvandoStatus">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="salvarNovoStatusAgendamento()" [disabled]="salvandoStatus">
          {{ salvandoStatus ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>

  <div class="modal-backdrop-custom" *ngIf="exibirModalLinkMeeting">
    <div class="modal-card">
      <div class="modal-card-header">
        <h5 class="mb-0">Link da Reunião</h5>
        <button type="button" class="btn-close" (click)="fecharModalLinkMeeting()"></button>
      </div>

      <div class="modal-card-body">
        <p *ngIf="carregandoLinkMeeting" class="mb-0 text-muted">Carregando dados da reunião...</p>

        <div *ngIf="!carregandoLinkMeeting && !meetingInfo" class="text-muted">
          Nenhuma sala de reunião encontrada para este atendimento.
        </div>

        <div *ngIf="!carregandoLinkMeeting && meetingInfo">
          <div class="meeting-info-row mb-2"><strong>Expiração:</strong> {{ formatarDataMeeting(meetingInfo.endDate) }}</div>
          <div class="meeting-info-row mb-2"><strong>Sala:</strong> {{ meetingInfo.roomName }}</div>
          <div class="meeting-info-row mb-3"><strong>Status:</strong> {{ meetingInfo.status }}</div>

          <div class="meeting-link-row mb-3">
            <label class="form-label"><strong>Host</strong></label>
            <div class="input-group">
              <input class="form-control" [value]="meetingInfo.hostUrl" readonly />
              <a class="btn btn-outline-primary" [href]="meetingInfo.hostUrl" target="_blank" rel="noopener">Abrir</a>
            </div>
          </div>

          <div class="meeting-link-row">
            <label class="form-label"><strong>Cliente</strong></label>
            <div class="input-group">
              <input class="form-control" [value]="meetingInfo.clienteUrl" readonly />
              <a class="btn btn-outline-primary" [href]="meetingInfo.clienteUrl" target="_blank" rel="noopener">Abrir</a>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-card-footer">
        <button type="button" class="btn btn-light" (click)="fecharModalLinkMeeting()">Fechar</button>
      </div>
    </div>
  </div>
</div> 